export const WEEKDAYS = [
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi'
];

export const MENU_COLUMN_DEFS = [
  { key: 'date', header: 'Tarih' },
  { key: 'day', header: 'Gün' },
  { key: 'soup', header: 'Çorba' },
  { key: 'main', header: 'Ana Yemek' },
  { key: 'side', header: 'Yan Yemek' },
  { key: 'extra', header: 'Ekstra' },
  { key: 'serviceWindow', header: 'Servis Saati' }
];

const normalizeText = (value) => String(value ?? '').toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim();
const pad = (value) => String(value).padStart(2, '0');
export const getMonthKey = (date = new Date()) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;
export const toDateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const dayName = (date) => date.toLocaleDateString('tr-TR', { weekday: 'long' }).replace(/^./, (letter) => letter.toLocaleUpperCase('tr-TR'));
export const formatMenuDate = (value) => {
  if (!value) return '';
  const [year, month, day] = String(value).split('-');
  return year && month && day ? `${day}.${month}.${year}` : String(value);
};

const parseDateValue = (value) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) return toDateKey(value);
  const text = String(value ?? '').trim();
  const tr = text.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  if (tr) return `${tr[3]}-${pad(tr[2])}-${pad(tr[1])}`;
  const iso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  return iso ? `${iso[1]}-${pad(iso[2])}-${pad(iso[3])}` : '';
};

export const emptyMenuRow = (date) => {
  const parsed = new Date(`${date}T12:00:00`);
  return { date, day: dayName(parsed), soup: '', main: '', side: '', extra: '', serviceWindow: '12:00 - 14:00' };
};

export const buildMonthRows = (monthKey = getMonthKey()) => {
  const [year, month] = monthKey.split('-').map(Number);
  const lastDay = new Date(year, month, 0).getDate();
  return Array.from({ length: lastDay }, (_, index) => new Date(year, month - 1, index + 1))
    .filter((date) => date.getDay() >= 1 && date.getDay() <= 6)
    .map((date) => emptyMenuRow(toDateKey(date)));
};

export const normalizeLunchMenu = (menu = [], monthKey = getMonthKey()) => {
  const legacyByDay = new Map(menu.filter((row) => !row.date).map((row) => [row.day, row]));
  const byDate = new Map(menu.filter((row) => row.date).map((row) => [parseDateValue(row.date), row]));
  return buildMonthRows(monthKey).map((row) => ({ ...row, ...(byDate.get(row.date) || legacyByDay.get(row.day) || {}), date: row.date, day: row.day }));
};

export const buildMenuTemplateMatrix = (monthKey = getMonthKey()) => [
  MENU_COLUMN_DEFS.map((column) => column.header),
  ...buildMonthRows(monthKey).map((row) => [formatMenuDate(row.date), row.day, '', '', '', '', row.serviceWindow])
];

const HEADER_LOOKUP = MENU_COLUMN_DEFS.reduce((lookup, column) => ({ ...lookup, [normalizeText(column.header)]: column.key }), {});

export const parseMenuSpreadsheetRows = (rows = []) => {
  const mapped = rows.map((row) => {
    const record = {};
    Object.entries(row || {}).forEach(([header, value]) => {
      const key = HEADER_LOOKUP[normalizeText(header)];
      if (key) record[key] = key === 'date' ? parseDateValue(value) : String(value ?? '').trim();
    });
    return record;
  }).filter((row) => Object.values(row).some(Boolean));

  if (!mapped.length) throw new Error('Dosyada geçerli menü satırı bulunamadı.');
  if (mapped.some((row) => !row.date)) throw new Error('Her satırda gg.aa.yyyy biçiminde geçerli bir tarih olmalıdır.');
  const duplicate = mapped.find((row, index) => mapped.findIndex((item) => item.date === row.date) !== index);
  if (duplicate) throw new Error(`${formatMenuDate(duplicate.date)} tarihi birden fazla kez girilmiş.`);

  return mapped.map((row) => {
    const base = emptyMenuRow(row.date);
    return { ...base, ...row, day: base.day };
  }).sort((left, right) => left.date.localeCompare(right.date));
};
